<kwo-header></kwo-header>

<div class="page-content">
	<ng-content></ng-content>
</div>